module.exports = __webpack_public_path__ + "img/ltkbump-2x.f622a35.jpg";